import { PlatformEnvironment } from '@mews/enums';

export const customWorkspaceAllowedEnvs = [
    PlatformEnvironment.Demo,
    PlatformEnvironment.Development,
    PlatformEnvironment.Feature,
    PlatformEnvironment.Test,
];

export const MewsReportingTracking = 'mews-reporting';

export enum MewsReportingTrackingEvents {
    EmbeddedReportRendered = 'Embedded report rendered',
    EmbeddedReportLoaded = 'Embedded report loaded',
    EmbeddedReportFilterChanged = 'Embedded report filter changed',
    EmbeddedReportServiceFilterChanged = 'Embedded report service filter changed',
    FailedToFetchGDParams = 'Failed to fetch goodDataParameters',
}

export enum GDProduct {
    Internal = 'internal',
    MewsBI = 'mewsbi',
}
